import { application } from "./application"

// registra qui i controller che usi
import HotspotEditorController from "./hotspot_editor_controller"
application.register("hotspot-editor", HotspotEditorController)